/* eslint-disable @typescript-eslint/no-explicit-any, @typescript-eslint/no-unused-vars */
import {
  TEXT,
  IMAGE,
  LAYOUT_LIST,
  LAYOUT_COLUMNS,
  DRAG_AND_DROP_CONTEXT_ROOT
} from '../items';
import { CardHelper } from './itemHelpers/CardHelper';
import { Translator } from '../Translator';
import { translate } from './translate';

const mapper = {
  TEXT: {
    type: TEXT,
    valuesGenerator: (item: any) => ({
      value: item.title,
      variant: 'text'
    })
  },
  LAYOUT: {
    type: LAYOUT_COLUMNS,
    valuesGenerator: (_item: any) => {
      return {
        gridTemplateColumns: { _: '1fr', lg: '1fr 3fr' }
      };
    }
  },
  IMAGE: {
    type: IMAGE,
    valuesGenerator: (item: any) => ({
      url: item.pictures?.[0].mediaUrl,
      alt: item.pictures?.[0].name
    })
  }
};
export const DragNDrop: Translator = sequence => {
  const root = translate(sequence, (item: any) => {
    let type = item.type;
    if (item.type === 'TEXT' && !item.title && item.pictures?.length > 0) {
      type = 'IMAGE';
    }

    return {
      id: item.id,
      type: (mapper as any)[type].type,
      values: (mapper as any)[type].valuesGenerator(item),
      items:
        item.items?.length > 0
          ? item.items.map((item: any) => {
              let type = item.type;
              if (
                item.type === 'TEXT' &&
                !item.title &&
                item.pictures?.length > 0
              ) {
                type = 'IMAGE';
              }

              return {
                id: item.id,
                type: (mapper as any)[type].type,
                values: (mapper as any)[type].valuesGenerator(item),
                items: []
              };
            })
          : []
    };
  }).withTransform(root => ({
    ...root,
    items: [
      {
        id: sequence.id,
        type: DRAG_AND_DROP_CONTEXT_ROOT,
        values: {
          items: JSON.stringify(sequence)
        },
        items: [
          {
            id: '1',
            type: LAYOUT_LIST,
            values: {
              align: 'center',
              padded: true
            },
            items: [
              CardHelper(
                {
                  title: '',
                  subtitle: '',
                  body: ''
                } as any,
                {
                  width: '80%',
                  height: 'auto',
                  padding: { _: '0px', md: '80px' },
                  extraItems: root.items
                }
              )
            ]
          }
        ]
      }
    ]
  }));

  return root;
};
